import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import About from "../pages/About";
import CompareRunsContainer from "../containers/CompareRunsContainer";
import ManageDataContainer from "../containers/ManageDataContainer";
import PrepareDataContainer from "../containers/PrepareDataContainer";
import RunHistoryContainer from "../containers/RunHistoryContainer";
import StartRunContainer from "../containers/StartRunContainer";
import ViewRunContainer from "../containers/ViewRunContainer";

const styles = {
    content: {
        height: "calc(100% - 48px)",
    },
};

const AppContent = (props) => {
    return (
        <div style={styles.content}>
            <Switch>
                <Route
                    exact
                    path="/"
                    component={About}
                />
                <Route
                    path="/startrun"
                    component={StartRunContainer}
                />
                <Route
                    path="/viewrun"
                    component={ViewRunContainer}
                />
                <Route
                    path="/compareruns"
                    component={CompareRunsContainer}
                />
                <Route
                    path="/history"
                    component={RunHistoryContainer}
                />
                <Route
                    path="/preparedata"
                    component={PrepareDataContainer}
                />
                <Route
                    path="/managedata"
                    component={ManageDataContainer}
                />
            </Switch>
        </div>
    );
};

export default withRouter(AppContent);
